import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const ResultInfo = () => {
  const { t } = useTranslation('map');

  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );

  const distance = Math.abs(
    firstDestination.northcoastKm - secondDestination.northcoastKm
  );

  return (
    <Container>
      <span className="distance">
        {distance}
        {t('km')}
      </span>

      <span className="info">{`${t('from')} ${firstDestination.name} ${t(
        'to'
      )} ${secondDestination.name}`}</span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .distance {
    color: #015c9a;
    font-size: 41px;
    font-family: materialBold;
  }

  .info {
    color: #2c3138;
    font-size: 17px;
    font-family: materialMedium;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    text-align: start;
    align-items: start;
    .distance {
      color: #2c3138;
      font-size: 27px;
    }

    .info {
      font-size: 14px;
    }
  }
`;

export default ResultInfo;
